import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AddInvoiceDialog } from "@/components/invoice/header/AddInvoiceDialog";
import { useTranslation } from "react-i18next";

interface EmptyStateProps {
  filter: "all" | "scheduled" | "unscheduled" | "paid" | "unpaid" | "recipient";
}

export const EmptyState = ({ filter }: EmptyStateProps) => {
  const { t } = useTranslation();

  if (filter === "recipient") {
    return (
      <div className="flex flex-col items-center justify-center py-8 sm:py-12 px-4">
        <div className="rounded-full bg-white p-3 sm:p-4 border border-[#34375B]">
          <FileText className="h-6 w-6 sm:h-8 sm:w-8 text-[#34375B]" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-8 sm:py-12 px-4 space-y-3 sm:space-y-4 text-center">
      <div className="rounded-full bg-[#F1F6F5] p-3 sm:p-4 border border-[#34375B]">
        <FileText className="h-6 w-6 sm:h-8 sm:w-8 text-[#34375B]" />
      </div>
      <h3 className="text-base sm:text-lg text-[#34375B]">{t("dashboard.you_have_no_invoices")}</h3>
      <AddInvoiceDialog
        trigger={
          <Button
            variant="link"
            className="h-auto p-0 text-primary hover:text-primary/90 text-sm sm:text-base"
          >
            {t("dashboard.add_an_invoice")}
          </Button>
        }
      />
    </div>
  );
};

